module.exports = __webpack_public_path__ + "iconmonstr-google-plus-1-48.png?d79f51ce8581fbce8dcd39b71f9f35e8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iconmonstr-google-plus-1-48.png
// module id = 90
// module chunks = 0